import {Component, Input, OnInit} from '@angular/core';
import {DialogRef, DialogService} from '@progress/kendo-angular-dialog';
import {EstoqueService} from '../../services/estoque.service';
import {
  CadApresentacaoCompraComponent
} from '../cad-apresentacao-compra/cad-apresentacao-compra.component';

@Component({
  selector: 'app-apresentacoes-compra',
  templateUrl: './apresentacoes-compra.component.html',
  styleUrls: ['./apresentacoes-compra.component.scss']
})
export class ApresentacoesCompraComponent implements OnInit {
  @Input() grupos: any[] = [];

  apresentacoes: any[] = [];
  apresentacoesFiltradas: any[] = [];
  apresentacoesPorEmbalagem: any = {};
  embalagensFiltro: any[] = [];
  filtroTexto = '';
  embalagemFiltroId: number = null;
  somenteComPendencias = false;
  fornecimentoConfigurado = false;
  carregando = false;
  mensagemErro: string;
  apresentacaoRemover: any;
  removendo = false;

  constructor(
    private estoqueService: EstoqueService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.carregueDados();
  }

  carregueDados(): void {
    this.carregando = true;
    this.mensagemErro = null;
    Promise.all([
      this.estoqueService.listeApresentacoesCompraGlobais(),
      this.estoqueService.obtenhaCatalogoComprasInternas()
    ]).then((resultados: any[]) => {
      this.apresentacoes = resultados[0] || [];
      this.fornecimentoConfigurado = !!(resultados[1] && resultados[1].fornecimento);
      if(!this.fornecimentoConfigurado)
        this.somenteComPendencias = false;
      this.apliqueResumoDeParas(resultados[1]);
      this.atualizeEmbalagensFiltro();
      this.apliqueFiltro();
      this.carregando = false;
    }).catch((erro: any) => {
      this.mensagemErro = erro;
      this.carregando = false;
    });
  }

  abraModalApresentacao(apresentacao: any = null, abaInicial = 0): void {
    this.limpeMensagens();
    const windowRef: DialogRef = CadApresentacaoCompraComponent.abraModal(
      this.dialogService,
      apresentacao,
      null,
      abaInicial,
      this.grupos
    );
    windowRef.result.subscribe((salva: any) => {
      if(salva && salva.id){
        const indice = this.apresentacoes.findIndex(
          item => Number(item.id) === Number(salva.id)
        );
        if(indice >= 0)
          this.apresentacoes[indice] = salva;
        else
          this.apresentacoes.push(salva);
        this.ordeneApresentacoes();
      }
    });
  }

  abraVinculos(apresentacao: any): void {
    this.abraModalApresentacao(apresentacao, 1);
  }

  editeApresentacao(evento: any): void {
    this.abraModalApresentacao(evento.dataItem);
  }

  podeRemover(apresentacao: any): boolean {
    return Number(apresentacao && apresentacao.totalVinculos || 0) === 0;
  }

  abraRemocao(evento: any): void {
    if(!this.podeRemover(evento.dataItem))
      return;
    this.apresentacaoRemover = evento.dataItem;
    this.mensagemErro = null;
  }

  confirmeRemocao(): void {
    if(!this.apresentacaoRemover || this.removendo)
      return;
    this.removendo = true;
    this.estoqueService.removaApresentacaoCompraGlobal(
      Number(this.apresentacaoRemover.id)
    ).then(() => {
      const idRemovido = Number(this.apresentacaoRemover.id);
      this.apresentacoes = this.apresentacoes.filter(
        item => Number(item.id) !== idRemovido
      );
      this.removendo = false;
      this.apresentacaoRemover = null;
      this.atualizeEmbalagensFiltro();
      this.apliqueFiltro();
    }).catch((erro: any) => {
      this.mensagemErro = erro;
      this.removendo = false;
      this.apresentacaoRemover = null;
    });
  }

  canceleRemocao(): void {
    if(!this.removendo)
      this.apresentacaoRemover = null;
  }

  filtrePorTexto(texto: string): void {
    this.filtroTexto = texto || '';
    this.apliqueFiltro();
  }

  filtrePorEmbalagem(embalagemId: number): void {
    this.embalagemFiltroId = embalagemId;
    this.apliqueFiltro();
  }

  filtrePorPendencias(somenteComPendencias: boolean): void {
    this.somenteComPendencias = !!somenteComPendencias;
    this.apliqueFiltro();
  }

  limpeFiltros(): void {
    this.filtroTexto = '';
    this.embalagemFiltroId = null;
    this.somenteComPendencias = false;
    this.apliqueFiltro();
  }

  possuiFiltro(): boolean {
    return !!this.filtroTexto ||
      this.somenteComPendencias ||
      (this.embalagemFiltroId !== null && this.embalagemFiltroId !== undefined);
  }

  formateFator(valor: any): string {
    const numero = Number(valor);
    return Number.isFinite(numero)
      ? numero.toLocaleString('pt-BR', {maximumFractionDigits: 6})
      : String(valor || '');
  }

  private ordeneApresentacoes(): void {
    this.apresentacoes = this.apresentacoes.slice().sort((a, b) => {
      if(!!a.ativa !== !!b.ativa)
        return a.ativa ? -1 : 1;
      return String(a.descricao).localeCompare(String(b.descricao));
    });
    this.atualizeEmbalagensFiltro();
    this.apliqueFiltro();
  }

  private apliqueFiltro(): void {
    const texto = this.normalizeTexto(this.filtroTexto);
    this.apresentacoesFiltradas = (this.apresentacoes || []).filter((apresentacao: any) => {
      const embalagemId = apresentacao.tipoEmbalagem
        ? Number(apresentacao.tipoEmbalagem.id)
        : null;
      const correspondeAEmbalagem = this.embalagemFiltroId === null ||
        this.embalagemFiltroId === undefined || embalagemId === Number(this.embalagemFiltroId);
      const correspondeAPendencia = !this.somenteComPendencias ||
        Number(apresentacao.totalPendenciasDePara || 0) > 0;
      const dadosParaBusca = this.normalizeTexto([
        apresentacao.descricao,
        apresentacao.tipoEmbalagem && apresentacao.tipoEmbalagem.nome,
        apresentacao.unidadeBase && apresentacao.unidadeBase.nome,
        apresentacao.unidadeBase && apresentacao.unidadeBase.sigla
      ].join(' '));
      return correspondeAEmbalagem && correspondeAPendencia &&
        (!texto || dadosParaBusca.includes(texto));
    });
    this.apresentacoesPorEmbalagem = this.agrupePorEmbalagem(this.apresentacoesFiltradas);
  }

  private agrupePorEmbalagem(apresentacoes: any[]): any {
    return (apresentacoes || []).reduce((grupos: any, apresentacao: any) => {
      const embalagemId = Number(apresentacao.tipoEmbalagem.id);
      if(!grupos[embalagemId])
        grupos[embalagemId] = [];
      grupos[embalagemId].push(apresentacao);
      return grupos;
    }, {});
  }

  private atualizeEmbalagensFiltro(): void {
    const embalagensPorId = new Map<number, any>();
    (this.apresentacoes || []).forEach((apresentacao: any) => {
      const embalagem = apresentacao.tipoEmbalagem;
      if(embalagem && embalagem.id !== null && embalagem.id !== undefined)
        embalagensPorId.set(Number(embalagem.id), embalagem);
    });
    this.embalagensFiltro = Array.from(embalagensPorId.values()).sort((a, b) =>
      String(a.nome || '').localeCompare(String(b.nome || ''), 'pt-BR')
    );

    if(this.embalagemFiltroId !== null && this.embalagemFiltroId !== undefined &&
      !embalagensPorId.has(Number(this.embalagemFiltroId)))
      this.embalagemFiltroId = null;
  }

  private normalizeTexto(valor: any): string {
    return String(valor || '').trim().toLocaleLowerCase('pt-BR')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  private apliqueResumoDeParas(catalogo: any): void {
    const porUnidade = new Map<number, any[]>();
    ((catalogo && catalogo.insumos) || []).forEach((item: any) =>
      (item.apresentacoes || []).forEach((apresentacao: any) => {
        const id = Number(apresentacao.apresentacaoCompraId);
        if(!porUnidade.has(id))
          porUnidade.set(id, []);
        porUnidade.get(id).push(apresentacao);
      })
    );
    this.apresentacoes.forEach(apresentacao => {
      const vinculos = porUnidade.get(Number(apresentacao.id)) || [];
      apresentacao.totalDeParas = vinculos.filter(item =>
        item.status === 'VINCULADO' && item.vinculo && item.vinculo.disponivel
      ).length;
      apresentacao.totalPendenciasDePara = vinculos.length - apresentacao.totalDeParas;
    });
  }

  private limpeMensagens(): void {
    this.mensagemErro = null;
  }
}
